export const navLinks = [
  { label: "本期导读", href: "#verify" },
  { label: "地址速览", href: "#address" },
  { label: "打不开排查", href: "#trouble" },
  { label: "话题墙", href: "#topic" },
  { label: "封面精选", href: "#picks" },
  { label: "读者讨论", href: "#talk" },
  { label: "常见问题", href: "#faq" },
];

export const keywordRibbon = [
  "金桔影院官网",
  "最新地址",
  "网址入口",
  "打不开怎么办",
  "线路切换",
  "访问核对",
  "移动端观看",
  "收藏夹整理",
];

export const heroStats = [
  { value: "3 步", label: "开工前先核对", desc: "域名 · 网络 · 入口" },
  { value: "6 类", label: "打不开场景", desc: "逐条给出应对思路" },
  { value: "常更新", label: "地址与入口", desc: "失效线路及时标注" },
];

export const verifySteps = [
  {
    no: "01",
    title: "先核对域名与拼写",
    desc: "很多“打不开”其实是地址敲错或点进了仿冒页面。对照本页给出的入口名称逐字核对，尤其注意结尾字符与相似字母，别从陌生聊天群里的短链直接进入。",
    tips: ["逐字对照拼写", "警惕来源不明的短链"],
    icon: "ri-link",
  },
  {
    no: "02",
    title: "再切换网络与设备",
    desc: "同一入口在流量与宽带上表现可能完全不同。可尝试切换 Wi-Fi 与移动数据，或换一台设备、换一个浏览器再打开，快速判断是线路问题还是设备缓存问题。",
    tips: ["Wi-Fi 与流量互换", "换浏览器或清缓存"],
    icon: "ri-wifi-off-line",
  },
  {
    no: "03",
    title: "最后更换入口线路",
    desc: "如果核对无误、网络也正常，就是当前线路拥挤或临时维护。回到地址速览里换一条标注为“通畅”的入口，通常能立刻恢复访问，不必反复刷新同一个地址。",
    tips: ["优先选通畅线路", "避开高峰时段"],
    icon: "ri-route-line",
  },
];

export const addresses = [
  {
    name: "主站入口",
    code: "MAIN · 线路 01",
    desc: "日常首选入口，页面结构与播放页最完整，适合长期加入收藏夹使用。",
    status: "通畅",
    tone: "ok",
    load: "访问稳定",
    updated: "2026-10-08",
  },
  {
    name: "备用线路",
    code: "BACKUP · 线路 02",
    desc: "主站拥挤或维护时的替代入口，播放能力一致，加载稍快于高峰主站。",
    status: "通畅",
    tone: "ok",
    load: "高峰更顺",
    updated: "2026-10-09",
  },
  {
    name: "移动端入口",
    code: "MOBILE · 线路 03",
    desc: "针对手机浏览器优化，按钮更大、竖屏播放更贴合，适合通勤时观看。",
    status: "通畅",
    tone: "ok",
    load: "移动优先",
    updated: "2026-10-08",
  },
  {
    name: "直连入口",
    code: "DIRECT · 线路 04",
    desc: "少了跳转环节，打开更快，但部分网络环境下可能被拦截，建议作为备用。",
    status: "维护中",
    tone: "warn",
    load: "间歇可用",
    updated: "2026-10-10",
  },
];

export const troubleshoots = [
  {
    q: "页面一直转圈，就是加载不出来",
    reason: "多数是当前线路拥挤，或设备端缓存了旧的页面文件。",
    action: "先换一条“通畅”入口；若仍转圈，清理浏览器缓存后重开，一般两分钟内可恢复。",
    tag: "加载超时",
  },
  {
    q: "提示“无法访问此网站”或连接被重置",
    reason: "当前网络对域名做了限制，或 DNS 解析还没更新到最新地址。",
    action: "切换移动数据与 Wi-Fi 各试一次，再改用备用线路入口，避免持续刷新同一地址。",
    tag: "无法访问",
  },
  {
    q: "打开后跳到别的页面或弹出一堆窗口",
    reason: "可能误入了仿冒入口，这类页面的按钮和弹窗往往异常密集。",
    action: "立刻关闭并回到本页地址速览，重新从标注的入口进入，不要在新弹窗里输入任何信息。",
    tag: "跳转异常",
  },
  {
    q: "能进网站，但视频一直缓冲卡顿",
    reason: "高峰时段带宽紧张，或当前画质档位超出了网络承载。",
    action: "把清晰度调低一档，错开晚间高峰再试，或改用移动端入口以获取更轻量的播放页。",
    tag: "播放卡顿",
  },
  {
    q: "手机能打开，电脑却打不开",
    reason: "电脑端可能开着旧版浏览器，或被本地安全软件、插件拦截。",
    action: "先换成主流新版浏览器，暂时停用可疑拦截插件，再对照电脑端与移动端两条不同入口。",
    tag: "端差异",
  },
  {
    q: "收藏夹里的旧地址彻底失效了",
    reason: "旧域名可能已经更换，继续访问只会一直报错。",
    action: "删除失效收藏，用本页最新地址重新收藏，并额外保留一条备用线路，避免下次再扑空。",
    tag: "旧地址失效",
  },
];

export const topics = [
  { name: "最新地址", heat: 982, group: "入口" },
  { name: "网址入口", heat: 875, group: "入口" },
  { name: "打不开怎么办", heat: 843, group: "排查" },
  { name: "线路切换", heat: 621, group: "排查" },
  { name: "域名核对", heat: 508, group: "排查" },
  { name: "移动端观看", heat: 466, group: "使用" },
  { name: "高峰期卡顿", heat: 412, group: "使用" },
  { name: "收藏夹整理", heat: 358, group: "使用" },
  { name: "仿冒入口识别", heat: 331, group: "安全" },
  { name: "常见问题", heat: 297, group: "安全" },
  { name: "观影指南", heat: 264, group: "使用" },
  { name: "入口更新提醒", heat: 219, group: "入口" },
];

export const topicGroups = ["全部", "入口", "排查", "使用", "安全"];

export const coverPicks = [
  {
    title: "长夜放映厅",
    category: "科幻",
    rating: "9.1",
    desc: "一座只在午夜营业的影院，放映的全是观众自己没看完的梦。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20film%20poster%20illustration%20of%20a%20futuristic%20cinema%20hall%20at%20night%2C%20warm%20kumquat%20orange%20neon%20glow%20against%20deep%20cream%20paper%20background%2C%20abstract%20geometric%20architecture%2C%20single%20silhouette%20figure%2C%20cinematic%20minimal%20composition%2C%20subtle%20paper%20grain%20texture%2C%20artistic%20and%20elegant%2C%20high%20detail&width=600&height=900&seq=jv-cover-scifi-01&orientation=portrait",
  },
  {
    title: "巷口的午后",
    category: "剧情",
    rating: "8.7",
    desc: "旧巷子里的一间录像店，替三代人保存着同一段夏天。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20film%20poster%20illustration%20of%20a%20warm%20sunny%20alley%20corner%20with%20an%20old%20video%20store%2C%20kumquat%20orange%20and%20cream%20tones%2C%20soft%20afternoon%20light%2C%20abstract%20minimal%20shapes%2C%20nostalgic%20mood%2C%20paper%20texture%20background%2C%20artistic%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=jv-cover-drama-02&orientation=portrait",
  },
  {
    title: "第七盘磁带",
    category: "悬疑",
    rating: "8.9",
    desc: "六盘磁带回放完毕，唯独第七盘，录音里出现了明天的对话。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20mystery%20film%20poster%20illustration%20with%20vintage%20cassette%20tape%20and%20mirrored%20corridor%2C%20warm%20orange%20highlights%20on%20dark%20cream%20textured%20background%2C%20abstract%20shadow%20geometry%2C%20tense%20minimal%20composition%2C%20artistic%20suspense%20mood%2C%20high%20detail&width=600&height=900&seq=jv-cover-mystery-03&orientation=portrait",
  },
  {
    title: "桔灯与海",
    category: "动画",
    rating: "9.3",
    desc: "小桔灯漂过整片海，只为把一句话送到岸的另一边。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20animation%20film%20poster%20illustration%20of%20a%20tiny%20glowing%20lantern%20drifting%20across%20a%20gentle%20sea%2C%20warm%20kumquat%20orange%20against%20creamy%20sunset%20sky%2C%20abstract%20waves%2C%20soft%20rounded%20shapes%2C%20gentle%20storybook%20composition%2C%20paper%20texture%20background%2C%20high%20detail&width=600&height=900&seq=jv-cover-anime-04&orientation=portrait",
  },
  {
    title: "两站路的距离",
    category: "爱情",
    rating: "8.4",
    desc: "他们总是在同一趟末班车上错过，只差一站。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20romance%20film%20poster%20illustration%20of%20a%20late%20night%20tram%20stop%2C%20two%20faint%20figures%20at%20opposite%20ends%2C%20warm%20kumquat%20orange%20street%20light%20on%20cream%20backdrop%2C%20abstract%20minimal%20urban%20shapes%2C%20quiet%20emotional%20mood%2C%20paper%20texture%2C%20artistic%20composition%2C%20high%20detail&width=600&height=900&seq=jv-cover-romance-05&orientation=portrait",
  },
  {
    title: "山那边的信号",
    category: "纪录",
    rating: "8.6",
    desc: "跟随一位乡村放映员，记录他用一台放映机走了二十年山路。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20film%20poster%20illustration%20of%20rolling%20mountains%20at%20dusk%20with%20a%20tiny%20projection%20beam%20crossing%20the%20ridge%2C%20warm%20orange%20gradient%20on%20cream%20textured%20paper%20background%2C%20abstract%20topographic%20lines%2C%20calm%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=jv-cover-doc-06&orientation=portrait",
  },
];

export const comments = [
  {
    name: "晚风与旧胶片",
    initial: "晚",
    time: "3 小时前",
    content: "按第一步逐字核对了域名才发现自己一直在用错地址，换回主站入口一下就进去了，白折腾我半天。",
    likes: 128,
    badge: "高赞",
  },
  {
    name: "只看竖屏",
    initial: "竖",
    time: "6 小时前",
    content: "移动端入口是真的顺手，通勤路上不用来回缩放，建议手机党直接收藏这条。",
    likes: 96,
    badge: "实用",
  },
  {
    name: "周五夜猫子",
    initial: "夜",
    time: "昨天",
    content: "晚上八点多主站有点挤，切到备用线路立刻就好了，早知道就不一直刷新同一个页面了。",
    likes: 74,
    badge: "",
  },
  {
    name: "老陈的放映机",
    initial: "陈",
    time: "昨天",
    content: "最有用的是那段“仿冒入口识别”，之前点陌生短链弹了一堆窗口，现在只认这篇里列的入口。",
    likes: 61,
    badge: "",
  },
  {
    name: "一杯桔子汽水",
    initial: "桔",
    time: "2 天前",
    content: "建议官方把地址更新提醒也放上来，收藏夹里那几条早就过期了，每次都要重新找。",
    likes: 43,
    badge: "",
  },
];

export const faqs = [
  {
    q: "金桔影院最新地址在哪里能核对到？",
    a: "本页顶部的“地址速览”就是为这个场景准备的，四条入口都标注了状态与更新时间，优先选择状态为“通畅”的那一条即可。",
  },
  {
    q: "金桔影院打不开是网站关了吗？",
    a: "先别急着下结论。多数情况是线路拥挤、网络限制或旧地址失效，按照“打不开排查”里的六类场景逐条对照，通常都能找到可用的替代入口。",
  },
  {
    q: "为什么同一时间别人能进，我却打不开？",
    a: "访问体验和本地网络、设备缓存、浏览器版本都有关。可以切换 Wi-Fi 与移动数据、换一台设备再试，用来判断是环境问题还是入口问题。",
  },
  {
    q: "收藏夹里的旧网址还值得留着吗？",
    a: "如果旧网址已经长期报错，建议直接删除并用本页最新地址重新收藏，同时额外保存一条备用线路，避免下次再次扑空。",
  },
  {
    q: "怎样避免进入仿冒页面？",
    a: "不要从陌生聊天群或弹窗里的短链进入，认准本页列出的入口名称与拼写；遇到按钮异常密集、疯狂弹窗的页面，立刻关闭。",
  },
];